import { Component } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { IRequestSearchResult } from '../models/search-result.model';
import { SearchRequestService } from '../services/search-request.service';
import { RequestDetailsViewComponent } from '../request-details-view/request-details-view.component';
import { SearchParameters } from '../../shared/models/searchParameters.model';
import { IRequestSearch } from '../models/search-request.model';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import {  ActivatedRoute } from '@angular/router';

@Component({
  selector: 'search-request-grid',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatDialogModule, MatProgressSpinnerModule, MatPaginatorModule],
  templateUrl: './search-request-grid.component.html',
  styleUrl: './search-request-grid.component.scss',
  providers: [DatePipe, TitleCasePipe]
})

export class SearchRequestGridComponent {
  isLoading: boolean = false;
  dataSource: MatTableDataSource<IRequestSearchResult>;
  pageSize: number = 10;
  pageIndex: number;
  totalCount: number;
  searchRequestParams: SearchParameters<IRequestSearch>;
  displayedColumns: string[] = ['number', 'request', 'requestDate', 'status', 'totalAmount'];
  searchDone: boolean = false;

  constructor(
    private searchRequestService: SearchRequestService, 
    private modal: MatDialog,
    private route: ActivatedRoute) {

      this.route.paramMap.subscribe(params => {
        var requestId = +params.get('id');

        if (requestId > 0) {        
          this.openDialog(requestId.toString());
        }
        });
      
   }

  public search(searchRequestParams: SearchParameters<IRequestSearch>): void {
    this.searchRequestParams = searchRequestParams;
    this.isLoading = true;
    this.searchRequestService.searchRequest(searchRequestParams).subscribe(data => {
      this.searchDone = true;
      this.isLoading = false;
      this.totalCount = data.totalCount;
      this.pageSize = data.pageSize;
      this.pageIndex = data.pageIndex;
      this.dataSource = new MatTableDataSource<IRequestSearchResult>(data.items);
    });
  }

  public pageChangeEvent(event?: PageEvent){
    this.searchRequestParams.pageIndex = event.pageIndex;
    this.searchRequestParams.pageSize = event.pageSize;
    this.search(this.searchRequestParams);
  }

  openDialog(requestNumber: string){
    this.modal.open(RequestDetailsViewComponent, {
            width: '1000px',
            data: { requestNumber: requestNumber }
          });
  }  
}